module.exports = __webpack_public_path__ + "img/undraw_online_payments_re_y8f2.6396354a.svg";